<p> {{item().title()}} select-filter works!</p>
